import React, { lazy, Suspense } from "react";
import { useSelector } from "react-redux";

import "../assets/css/utility/modal.css";

const VehicleLoadManageModal = lazy(() => import("../pages/LoadPost/Manage/components/LoadsInformation/Loader/LoadTypeManageModal/Vehicle"));
const PalletLoadManageModal = lazy(() => import("../pages/LoadPost/Manage/components/LoadsInformation/Loader/LoadTypeManageModal/Pallet"));
const BarrelLoadManageModal = lazy(() => import("../pages/LoadPost/Manage/components/LoadsInformation/Loader/LoadTypeManageModal/Barrel"));
const StonesLoadManageModal = lazy(() => import("../pages/LoadPost/Manage/components/LoadsInformation/Loader/LoadTypeManageModal/Stones"));
const SandLoadManageModal = lazy(() => import("../pages/LoadPost/Manage/components/LoadsInformation/Loader/LoadTypeManageModal/Sand"));
const LateriteLoadManageModal = lazy(() => import("../pages/LoadPost/Manage/components/LoadsInformation/Loader/LoadTypeManageModal/Laterite"));
const LoadDeleteModal = lazy(() => import("../pages/LoadPost/Manage/components/LoadsInformation/Loader/DeleteModal"));
const OfferDescriptionModal = lazy(() => import("../pages/Carrier/components/OfferDescriptionModal"));
const WithdrawConfirmModal = lazy(() => import("../pages/Withdraw/components/WithdrawConfirmModal"));
const CreateDisputeRequest = lazy(() => import("../pages/Order/Detail/components/Modals/CreateDisputeRequest"));
const WithdrawDisputeRequest = lazy(() => import("../pages/Order/Detail/components/Modals/WithdrawDisputeRequest"));
const OtherPartyAgree = lazy(() => import("../pages/Order/Detail/components/Modals/OtherPartyAgree"));
const DeliveryImage = lazy(() => import("../pages/Order/Detail/components/Modals/DeliveryImage"));
const OtherPartyDisagree = lazy(() => import("../pages/Order/Detail/components/Modals/OtherPartyDisagree"));

const Modal = () => {
  const modalStatus = useSelector((state) => state.modal.modalStatus);
  const modalName = useSelector((state) => state.modal.modalName);
  const modalData = useSelector((state) => state.modal.modalData);

  return (
    <div
      className="custom-modal"
      condition={modalStatus === "show" ? "open" : "close"}
    >
      <Suspense fallback={null}>
      {modalName === "VehicleLoadManageModal" ? (
        <VehicleLoadManageModal modalData={modalData} />
      ) : modalName === "LoadDeleteModal" ? (
        <LoadDeleteModal modalData={modalData} />
      ) : modalName === "PalletLoadManageModal" ? (
        <PalletLoadManageModal modalData={modalData} />
      ) : modalName === "BarrelLoadManageModal" ? (
        <BarrelLoadManageModal modalData={modalData} />
      ) : modalName === "StonesLoadManageModal" ? (
        <StonesLoadManageModal modalData={modalData} />
      ) : modalName === "SandLoadManageModal" ? (
        <SandLoadManageModal modalData={modalData} />
      ) : modalName === "OfferDescriptionModal" ? (
        <OfferDescriptionModal modalData={modalData} />
      ) : modalName === "WithdrawConfirmModal" ? (
        <WithdrawConfirmModal modalData={modalData} />
      ) : modalName === "CreateDisputeRequest" ? (
        <CreateDisputeRequest modalData={modalData} />
      ) : modalName === "WithdrawDisputeRequest" ? (
        <WithdrawDisputeRequest modalData={modalData} />
      ) : modalName === "OtherPartyAgree" ? (
        <OtherPartyAgree modalData={modalData} />
      ) : modalName === "DeliveryImage" ? (
        <DeliveryImage modalData={modalData} />
      ): modalName === "OtherPartyDisagree" ? (
        <OtherPartyDisagree modalData={modalData} />
      ): modalName === "LateriteLoadManageModal" ? (
        <LateriteLoadManageModal modalData={modalData} />
      ): null}
      </Suspense>
    </div>
  );
};

export default React.memo(Modal);
